import { TopMenu } from "../../top-menu/TopMenu";
import { Footer } from "../../footer/Footer";
import CompanyImage from '../../../assets/company.png';
import AISC from "../../../assets/aisc.png";
import NISD from "../../../assets/nisd.png";
import SDS from "../../../assets/sds2_certification-badge__Detailer.png";

export const Company = () => (
    <div className="min-h-screen flex flex-col">
        <TopMenu />
        <main className="flex-1 py-10 px-5 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-[60px]">
            <div className="text-justify">
                <h1 className="bg-navy text-white pl-2.5 mt-0">HISTORY</h1>
                <p>We have always operated at the leading edge of technology utilizing the latest in CAD, modeling, printing, scanning, BIM technology, etc, since 1993.</p>
                <p>We have been using SDS2 to model and detail shop drawings for our projects since 1998 and have progressed with technology advancements.</p>
                <p>Our staff has experience in all fields of structural &amp; miscellaneous steel including modeling, detailing, fabrication, and erection.</p>
                <p>With a specialization in complex structural and miscellaneous steel projects, we prepare high-quality shop drawings and models that ensure seamless fabrication and erection for our commercial, public works, and private projects.</p>
                <p>Jim Truitt, a respected leader in the steel industry, founded Rocky Point Detailing LLC and Aircad LLC in 1993. Under his leadership, the companies have successfully completed over 500 steel detailing projects, and his educational outreach has helped train hundreds of industry professionals. As a board member for the National Institute of Steel Detailers (NISD), Jim is an active advocate for quality and training, working to educate industry stakeholders on best practices. Jim is also a private pilot and enjoys flying to visit clients and jobsites throughout the western United States.</p>
            </div>

            <div className="md:col-span-2">
                <img src={CompanyImage} alt="Company" className="w-full" />
                <div className="flex flex-col sm:flex-row gap-10 mt-8 justify-end">
                    <div className="text-center">
                        <h2>Certifications</h2>
                        <div className="flex justify-center items-center gap-8">
                            <img src={SDS} alt="SDS2 Certified" className="w-24" />
                        </div>
                        <p>NISD CLASS I &amp; II DETAILERS<br />SDS2 CERTIFIED DETAILERS</p>
                    </div>
                    <div className="text-center">
                        <h2>Memberships</h2>
                        <div className="flex justify-center items-center gap-8">
                            <img src={AISC} alt="AISC" className="w-24" />
                            <img src={NISD} alt="NISD" className="w-24" />
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <Footer />
    </div>
);
